import { getCollectionData } from "./getCollection";
import { cgiService } from "../../services/cgiService/cgiService";
import { getResultByResponse } from "../common/getResultByResponse";
const getPageId = (options = {}) => {
  var _window$RUNTIME_CONFI, _window$xy_runtime_ut, _window$xy_runtime_ut2;
  const pageId = (options === null || options === void 0 ? void 0 : options.pageId) || ((_window$RUNTIME_CONFI = window.RUNTIME_CONFIGS) === null || _window$RUNTIME_CONFI === void 0 ? void 0 : _window$RUNTIME_CONFI.pageId) || '';
  if (pageId) return pageId;
  const info = (_window$xy_runtime_ut = window.xy_runtime_utils) === null || _window$xy_runtime_ut === void 0 || (_window$xy_runtime_ut2 = _window$xy_runtime_ut.getPageInfoFromRouter) === null || _window$xy_runtime_ut2 === void 0 ? void 0 : _window$xy_runtime_ut2.call(_window$xy_runtime_ut);
  return (info === null || info === void 0 ? void 0 : info.pageId) || '';
};
/**
 * 一个纯粹的请求数据源的方法，主要用于挂载到w.requestCgi上
 * @param collectionId
 * @param cgi
 * @param requestObj
 * @param options
 * @returns
 */
export async function requestCgi(collectionId, cgi, requestObj = {}, options = {}) {
  var _options$projectId, _options$envId, _options$simplifyCgiS, _options$useOrInstead, _options$batchEnabled;
  const projectId = (_options$projectId = options === null || options === void 0 ? void 0 : options.projectId) !== null && _options$projectId !== void 0 ? _options$projectId : window.w.projectId;
  const envId = (_options$envId = options === null || options === void 0 ? void 0 : options.envId) !== null && _options$envId !== void 0 ? _options$envId : window.w.env;
  const pageId = getPageId(options);
  const collection = await getCollectionData({
    collectionId,
    envId,
    pageId,
    projectId,
    useCache: true,
    simplifyCgiSchema: (_options$simplifyCgiS = options.simplifyCgiSchema) !== null && _options$simplifyCgiS !== void 0 ? _options$simplifyCgiS : true
  });
  if (!collection) throw new Error(`查找不到数据源「${collectionId}」的配置`);
  const cgiInfo = collection === null || collection === void 0 ? void 0 : collection.cgiInfo[cgi];
  const res = await cgiService.requestCgiWithMiddlewares({
    collection,
    cgiInfo: cgiInfo,
    collectionId,
    cgiName: cgi,
    envId,
    pageId,
    projectId,
    request: requestObj,
    raw: true,
    useOrInsteadOfIn: (_options$useOrInstead = options.useOrInsteadOfIn) !== null && _options$useOrInstead !== void 0 ? _options$useOrInstead : false,
    batchEnabled: (_options$batchEnabled = options.batchEnabled) !== null && _options$batchEnabled !== void 0 ? _options$batchEnabled : false
  });
  return getResultByResponse(res);
}
//# sourceMappingURL=requestCgi.js.map
